import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  workspaces: [], // Array of selected workspaces [{ id, name, ... }]
  files: {}, // { [workspaceId]: [files/documentTree] }
  excludedFileIds: [], // Array of excluded file IDs
  // Add other fields as needed for the site creation flow
};

const siteBuilderSlice = createSlice({
  name: 'siteBuilder',
  initialState,
  reducers: {
    setSiteBuilder: (state, action) => ({ ...state, ...action.payload }),
    clearSiteBuilder: (state) => {
      state.workspaces = [];
      state.files = {};
      state.excludedFileIds = [];
      return state;
    },

    // Set multiple workspaces at once
    setWorkspaces: (state, action) => {
      state.workspaces = action.payload;
    },

    // Add files to the document tree by workspace ID
    addFiles: (state, action) => {
      const { workspaceId, files } = action.payload;
      state.files[workspaceId] = files;
    },

    // Add files to excluded list
    addExcludedFiles: (state, action) => {
      const fileIds = Array.isArray(action.payload) ? action.payload : [action.payload];
      fileIds.forEach((id) => {
        if (!state.excludedFileIds.includes(id)) {
          state.excludedFileIds.push(id);
        }
      });
    },
  },
});

export const { setSiteBuilder, clearSiteBuilder, setWorkspaces, addFiles, addExcludedFiles } = siteBuilderSlice.actions;

export default siteBuilderSlice.reducer;
